module.exports = __webpack_public_path__ + "static/media/icn_clock.7007591d.svg";